// assets
import { IconNotification, IconSettings, IconBan, IconLetterCase } from '@tabler/icons';

// constant
const icons = { IconNotification, IconSettings, IconBan, IconLetterCase };

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const other = {
    id: 'system',
    title: '시스템',
    type: 'group',
    children: [
        //     {
        //     id: 'Notification',
        //     title: '공지',
        //     type: 'item',
        //     url: 'notification',
        //     icon: icons.IconNotification,
        //     breadcrumbs: false
        // },
        {
            id: 'SystemSetting',
            title: '시스템 설정',
            type: 'item',
            url: 'system-setting',
            icon: icons.IconSettings,
            breadcrumbs: false
        },
        {
            id: 'SensitiveWord',
            title: '금칙어',
            type: 'item',
            url: 'sensitive_word',
            icon: icons.IconLetterCase,
            breadcrumbs: false
        },

    ]


};

export default other;